jQuery(function($) {
  $(document).ready(function() {
//     $('.header').stick_in_parent({parent: 'body'});
    $('.product_details').stick_in_parent({
      offset_top: 150,
      byRow: false,
      parent: '.product_section'
    });
  });
});

// Can also be used with $(document).ready()
$(window).load(function() {
  $('.main.content .flexslider').flexslider({
    animation: "slide"
  });
});